import React, { useRef, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { formatBrowser } from '../utils/dateUtils';

export default function ChartPanel({ series = [], title = 'Chart', options = {} }) {
  Highcharts.setOptions({ time: { useUTC: false } });
  const chartComponentRef = useRef();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const chart = chartComponentRef.current?.chart;
      if (chart && chart.renderTo) {
        chart.reflow();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [series]);

  const units = [...new Set(series.map(s => s.unit))];

  const yAxes = units.map((unit, idx) => ({
    id: unit,
    title: { text: unit },
    labels: { format: `{value} ${unit}` },
    opposite: idx % 2 === 1
  }));

  const seriesWithAxis = series.map(s => ({
    ...s,
    yAxis: units.indexOf(s.unit)
  }));

  const chartOptions = {
    chart: {
      type: 'line',
      zoomType: 'xy',
      height: null,
      // resetZoomButton: {
      //   position: { align: 'right', x: 0, y: -45 },
      //   theme: {
      //     fill: '#0075C9',
      //     style: { color: '#fff', fontWeight: 'bold' },
      //     states: {
      //       hover: {
      //         fill: '#005b99',
      //         style: { color: 'white' }
      //       }
      //     }
      //   }
      // },
      ...(options.chart || {})
    },
    title: { text: title },
    credits: { enabled: false },
    xAxis: {
      type: 'datetime',
      crosshair: true,
      dateTimeLabelFormats: {
        millisecond: '%d/%m/%Y, %H:%M:%S',
        second: '%d/%m/%Y, %H:%M:%S',
        minute: '%d/%m/%Y, %H:%M',
        hour:   '%d/%m/%Y, %H:%M',
        day:    '%d/%m/%Y',
        week:   '%d/%m/%Y',
        month:  '%b %Y',
        year:   '%Y'
      }
    },
    yAxis: yAxes,
    plotOptions: {
      series: {
        marker: { enabled: false },
        turboThreshold: 0
      }
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const dateStr = formatBrowser(this.x, { seconds: true });
        const pointsStr = this.points.map(point => {
          const unit = point.series.userOptions.unit || '';
          return `<span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${point.y} ${unit}</b><br/>`;
        }).join('');
        return `<b>${dateStr}</b><br/>${pointsStr}`;
      }
    },
    series: seriesWithAxis,
    // ...options
  };

  return (
    <div style={{ width: '100%', height: '100%', minHeight: 300 }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        ref={chartComponentRef}
        containerProps={{ style: { width: '100%', height: '100%' } }}
      />
    </div>
  );
}
